import { Store } from './../../core/state/store';
import { ServicesState } from './services-state';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ServicesStore extends Store<ServicesState> {
  storeLastRouteParams(params: Params) {
    this.setState({
      ...this.state,
      lastRoute: { ...this.state.lastRoute, params: params },
    });
  }
  constructor() {
    super(new ServicesState());
  }

  storeLastRoute(route: string) {
    this.setState({
      ...this.state,
      lastRoute: { ...this.state.lastRoute, url: route },
    });
  }

  storeEditedAlarm(alarm: any) {
    this.setState({
      ...this.state,
      alarm: { ...alarm },
    });
  }

  clearEditedAlarm() {
    this.setState({
      ...this.state,
      alarm: undefined,
    });
  }
}
